import { Directive, ElementRef, Renderer2, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[nimbusAvatar]',
  standalone: false,
})
export class NimbusAvatarDirective implements OnInit, OnChanges {
  @Input() public hashBase: string;

  public constructor(
    private readonly el: ElementRef,
    private readonly renderer: Renderer2,
  ) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.hashBase && changes.hashBase.previousValue !== changes.hashBase.currentValue) {
      this.renderer.setStyle(this.el.nativeElement, 'background', 'var(--THEME-BUTTON-BACKGROUND-COLOR-NORMAL)');
    }
  }

  public ngOnInit(): void {
    this.renderer.setStyle(this.el.nativeElement, 'background', 'var(--THEME-BUTTON-BACKGROUND-COLOR-NORMAL)');
    this.renderer.addClass(this.el.nativeElement, 'avatar-small');
    this.renderer.addClass(this.el.nativeElement, 'avatar');
  }
}
